import {ITagItem} from "../utils/tag-util";

export function formatTagItem(tagItem: ITagItem) {
    return tagItem.label;
}

export function formatTagItems(tagItems: ITagItem[]) {
    return tagItems.map((c: any) => formatTagItem(c)).join(", ");
}
